import { apiGet, apiPost } from '@/lib/http/client';

import type { HubspotInstallResponse } from '../types';

export async function getHubspotInstallUrl(
  orgId: number | string,
  params?: { returnTo?: string; intent?: string }
): Promise<HubspotInstallResponse> {
  const filters: Record<string, string> = {};
  if (params?.returnTo) {
    filters.return_to = params.returnTo;
  }
  if (params?.intent) {
    filters.intent = params.intent;
  }
  return apiGet<HubspotInstallResponse>(
    `/api/orgs/${orgId}/hubspot/install/`,
    Object.keys(filters).length ? filters : undefined
  );
}

export async function disconnectHubspot(
  orgId: number | string
): Promise<{ success: boolean }> {
  return apiPost<{ success: boolean }>(
    `/api/orgs/${orgId}/hubspot/disconnect/`,
    {}
  );
}
